import React from 'react';
import styled from 'styled-components';
import { leadCapture } from 'utils';
import breakpoint from 'create-breakpoints';
import LayoutContainer from 'components/LayoutContainer';
import Button from 'components/Button';
import illustrationUrl from 'images/hero/ai-ad-network.svg';

const Intro = styled.header`
  --height: 500px;

  color: var(--text-white);
  background-color: var(--bg-blue);
  background-image: url(${illustrationUrl});
  background-position: top -80px right -10px;
  background-size: auto 400px;
  background-repeat: no-repeat;

  text-align: center;
  display: flex;
  align-items: flex-end;
  height: var(--height);
  padding: 36px 0;

  ${breakpoint.small`
    background-size: contain;
    text-align: left;
    align-items: center;
    padding: 0;
  `};

  ${breakpoint.medium`
    --height: 750px;

    background-color: transparent;
    background-position: top -36px right -30px;
    position: relative;
  `};

  ${breakpoint.medium`
    &::before,
    &::after {
      background-color: var(--bg-blue);
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      transform-origin: bottom right;
      z-index: -1;
    }

    &::before {
      transform: skewY(3.2deg) translateY(-36px);
    }

    &:after {
      transform: skewY(4.2deg);
      opacity: 0.06;
    }
  `}

  h1 {
    font-size: 26px;
    font-weight: var(--font-weight-normal);

    ${breakpoint.small`
      font-size: 35px;
    `}

    ${breakpoint.medium`
      font-size: 45px;
    `}

    ${breakpoint.large`
      font-size: 55px;
    `}
  }

  p {
    display: none;

    ${breakpoint.small`
      display: block;
      max-width: 30ch;
    `}

    ${breakpoint.medium`
      font-size: 18px;
      max-width: 40ch;
    `}

    ${breakpoint.large`
      max-width: 50ch;
    `}
  }
`;

export default () => (
  <Intro>
    <LayoutContainer>
      <h1>
        Targeted Job-Advertising <br /> Get more applications
      </h1>
      <p>
        MindMatch distributes your jobs across 50+ Job Boards and automatically targets relevant
        candidates on Social Media and Websites through our advertising engine.
      </p>
      <br />
      <br />
      <Button onClick={leadCapture}>Receive candidates</Button>
    </LayoutContainer>
  </Intro>
);
